import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FadeIn from 'react-fade-in';

import JBImage from 'components/essentials/JBImage';
import IconStarFull from 'components/icons/iconStarFull';
import isClient from 'commons/isClient';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import PDPPriceSection from '../../PDPPriceSection';

const PDPUpSellFlyOut = ({
  top,
  name,
  price,
  imageUrl,
  hidePrice,
  salePrice,
  promotion,
  optionPrice,
  description,
  totalReviews,
  averageRating,
}) => {
  const containerRef = useRef(null);
  const [height, setHeight] = useState(300);

  useEffect(() => {
    // wait for fade-in to get container height
    setTimeout(() => {
      const theHeight = containerRef.current?.getBoundingClientRect().height;
      if (theHeight) setHeight(theHeight);
    }, 100);
  }, []);

  let absTop = 0;

  // if container is at the top of the screen
  if (top < 0) {
    absTop = -top;
  }
  // if container is at the bottom of the screen
  else if (isClient() && window.innerHeight < top + height) {
    absTop = window.innerHeight - height - top;
  }

  return (
    <FadeIn>
      <div
        ref={containerRef}
        className="absolute z-10 left-[-450px] top-0 w-[400px] min-h-[255px] bg-white ml-[1.9rem] rounded-lg overflow-hidden"
        style={{ top: absTop }}
      >
        {imageUrl && (
          <JBImage
            src={imageUrl}
            width={400}
            loader={false}
            lazy={false}
            className="h-[156px] object-contain"
          />
        )}
        <div className="border border-solid border-gray-light8 rounded-bl-lg rounded-br-lg">
          <div className="pt-4 px-4 pb-0">
            <div className="text-xl font-bold mb-1">{name}</div>
            {!hidePrice && (
              <div className="flex text-xl font-bold mb-1">
                <PDPPriceSection
                  priceObj={price}
                  salePrice={salePrice}
                  promotion={promotion}
                  optionPrice={optionPrice}
                  variant="PDPUpSellFlyOut"
                />
                <div className="flex items-center ml-4 [&_span]:mr-2">
                  {averageRating > 0 && (
                    <>
                      <span>
                        <IconStarFull />
                      </span>
                      <span className="text-base font-bold">
                        {averageRating}/5
                      </span>
                    </>
                  )}
                  {totalReviews > 0 && (
                    <span className="text-base">
                      ({totalReviews} review{totalReviews > 1 ? 's' : ''})
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>

          <SanitizedHtml
            className="pt-0 px-4 pb-4 text-gray text-xs [&_p]:text-xs [&_p]:mb-4 [&_ul]:m-0 [&_ul]:pt-0 [&_ul]:pr-0 [&_ul]:pb-0 [&_ul]:pl-4 [&_ul_li]:mb-2"
            html={description}
          />
        </div>
      </div>
    </FadeIn>
  );
};

PDPUpSellFlyOut.propTypes = {
  top: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.object,
  optionPrice: PropTypes.number,
  salePrice: PropTypes.number,
  hidePrice: PropTypes.bool,
  imageUrl: PropTypes.string,
  description: PropTypes.string,
  totalReviews: PropTypes.number,
  averageRating: PropTypes.number,
  promotion: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default PDPUpSellFlyOut;
